// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kx-K","textarea":"styles_textarea__2Ygky"};